export const isHexColor = (color: string): boolean => {
  // eslint-disable-next-line regexp/no-unused-capturing-group
  return /^#([\dA-Fa-f]{6})$/u.test(color);
};
